import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTextareaAutocomplete from '@webscopeio/react-textarea-autocomplete';
import styled from 'styled-components';
import { Colors } from 'modules/theme';

const ItemComponent = styled.div`
  color: ${Colors.black2};
  padding-bottom: 5px;
  cursor: pointer;

  &: hover {
    opacity: 0.5;
  }
`;

const Item = ({ entity }) => <ItemComponent>{entity}</ItemComponent>;

Item.propTypes = {
  entity: PropTypes.string.isRequired,
};

const Loading = () => <div>Loading</div>;

class TextareaComponent extends Component {
  getHiglight = token => {
    const { higlights } = this.props;

    return higlights.filter(higlight => new RegExp(token, 'i').test(higlight));
  };

  handleChange = event => {
    const { onChange } = this.props;

    onChange(event.target.value);
  };

  render() {
    const { value, customStyles, disabled } = this.props;

    return (
      <ReactTextareaAutocomplete
        className="textarea-autocomplete"
        value={value}
        loadingComponent={Loading}
        onChange={this.handleChange}
        disabled={disabled}
        ref={rta => {
          this.rta = rta;
        }}
        innerRef={textarea => {
          this.textarea = textarea;
        }}
        rows={9}
        style={{
          ...customStyles,
        }}
        listStyle={{
          backgroundColor: Colors.white,
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
          padding: '15px',
          listStyleType: 'none',
        }}
        minChar={0}
        trigger={{
          ':': {
            dataProvider: token => this.getHiglight(token),
            component: Item,
            output: item => `<${item}>`,
          },
        }}
      />
    );
  }
}

TextareaComponent.propTypes = {
  placeholder: PropTypes.string,
  entity: PropTypes.string,
  higlights: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  value: PropTypes.string,
  customStyles: PropTypes.object,
  disabled: PropTypes.bool,
};

TextareaComponent.defaultProps = {
  placeholder: null,
  entity: null,
  higlights: [],
  onChange: null,
  hasError: false,
  value: '',
  customStyles: {},
  disabled: false,
};

export default TextareaComponent;
